/**
 * @Author: DJ
 * @Date:   2021-09-01 16:19:55
 * @Last Modified by:   DJ
 * @Last Modified time: 2021-09-01 16:26:46
 */
/**
 * 会员管理
 * */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { TabType } from './types';
import { connect } from 'react-redux';
import styles from './index.module.scss';
import { XTabNav } from '@/components/xqxc_ui';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
// import User from './user/main';
import Company from './company/main';

const tabList = [
    // { id: TabType.User, label: '用户' },
    { id: TabType.Company, label: '企业' },
];

const Member = (props) => {

    const [curTabID, setCurTabID] = useState(sessionStorage.getItem('user-member') || TabType.User);

    useEffect(() => {
        sessionStorage.getItem('user-member') && sessionStorage.removeItem('user-member');
        props.setBreadcrumbPaths(props.match);
    }, []);

    return (
        <Company key={curTabID} curTabID={curTabID}  {...props} />
        // <div className={styles.flexBoxContainer}>
        //     <XTabNav renderData={tabList} onChange={setCurTabID} activedID={curTabID} />
        //     {curTabID === TabType.User && <User key={curTabID} curTabID={curTabID} {...props} />}
        //     {curTabID === TabType.Company && <Company key={curTabID} curTabID={curTabID}  {...props} />}
        // </div>
    );
};

Member.propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,//路由对象
    setBreadcrumbPaths: PropTypes.func
};

export default connect(null, { setBreadcrumbPaths })(Member);